import { useRef, useState } from 'react';
import { toPng } from 'html-to-image';
import { BrandLogo } from '../components/BrandLogo';
import morningRun from '../assets/morning-run.webp';
import activePark from '../assets/active-park.webp';

const templates = [
  { id: 'fresh', name: 'Fresh Route', image: morningRun },
  { id: 'city', name: 'City Explorer', image: activePark },
  { id: 'eco', name: 'Eco Impact', image: morningRun },
];

export function StoryPage() {
  const storyRef = useRef<HTMLDivElement | null>(null);
  const [template, setTemplate] = useState(templates[0]);
  const [isExporting, setIsExporting] = useState(false);

  const renderStory = async () => {
    if (!storyRef.current) return null;
    setIsExporting(true);
    try {
      return await toPng(storyRef.current, { pixelRatio: 2, cacheBust: true, backgroundColor: '#0c5a36' });
    } finally {
      setIsExporting(false);
    }
  };

  const downloadStory = async () => {
    const dataUrl = await renderStory();
    if (!dataUrl) return;
    const link = document.createElement('a');
    link.download = 'jakcomfort-morning-run.webp';
    link.href = dataUrl;
    link.click();
  };

  const shareStory = async () => {
    const dataUrl = await renderStory();
    if (!dataUrl) return;
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], 'jakcomfort-story.png', { type: 'image/png' });
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ title: 'JakComfort Story', text: 'Aktivitasku bersama JakComfort', files: [file] });
    } else {
      await downloadStory();
      alert('File Story sudah diunduh. Bagikan secara manual melalui aplikasi pilihanmu.');
    }
  };

  return (
    <div className="app-page story-page">
      <header className="app-page__header">
        <div><span className="eyebrow">Story Maker</span><h1>Bagikan aktivitas sekaligus pesan lingkungan.</h1></div>
      </header>
      <div className="story-layout">
        <section className="story-controls">
          <span className="eyebrow">Pilih template</span>
          <div className="template-list">
            {templates.map((item) => (
              <button type="button" className={template.id === item.id ? 'is-active' : ''} key={item.id} onClick={() => setTemplate(item)}>
                <img src={item.image} alt="" /><strong>{item.name}</strong>
              </button>
            ))}
          </div>
          <div className="story-option-card"><strong>Data yang ditampilkan</strong><label><input type="checkbox" defaultChecked /> Comfort Score</label><label><input type="checkbox" defaultChecked /> Jarak & durasi</label><label><input type="checkbox" defaultChecked /> Paparan area hijau</label><label><input type="checkbox" defaultChecked /> Pesan edukasi</label></div>
          <div className="story-note"><strong>Tidak ada posting otomatis.</strong><p>Alurnya adalah buat, unduh, lalu bagikan setelah kamu menyetujui hasilnya.</p></div>
          <button type="button" className="button button--primary button--full" disabled={isExporting} onClick={downloadStory}>{isExporting ? 'Membuat gambar...' : 'Unduh Story'}</button>
          <button type="button" className="button button--ghost button--full" disabled={isExporting} onClick={shareStory}>Bagikan file</button>
        </section>

        <section className="story-preview-wrap">
          <div className={`story-preview story-preview--${template.id}`} ref={storyRef}>
            <img className="story-preview__background" src={template.image} alt="Latar aktivitas JakComfort" />
            <div className="story-preview__overlay" />
            <div className="story-preview__top"><BrandLogo light /><span>22 JUL 2026</span></div>
            <div className="story-preview__body">
              <span className="story-preview__label">MORNING RUN GBK</span>
              <div className="story-preview__score"><strong>78</strong><span>Comfort Score</span></div>
              <h2>Gerak lebih sehat di rute yang lebih hijau.</h2>
              <div className="story-preview__metrics"><div><strong>8,45</strong><span>KM</span></div><div><strong>54:32</strong><span>DURASI</span></div><div><strong>62%</strong><span>AREA HIJAU</span></div></div>
            </div>
            <div className="story-preview__footer"><p>Ruang hijau membantu aktivitas terasa lebih nyaman. Mari jaga bersama.</p><span>#JakComfort</span></div>
          </div>
        </section>
      </div>
    </div>
  );
}
